import { useSimilarProducts } from 'componentsV2/product/details/content/subpages/similar-products/hooks';
import { Customer } from 'Services/Mongo/Types';
import { ProductsEmptyState } from 'componentsV2/product/details/content/components';
import { Product } from '@setvi/shared/interfaces';
import {
  MobileProductCardProps,
  MobileProductListCard
} from '../../../list/components';
import { ListLoader } from '../../../list/components/product-card/list/components';

interface MobileSimilarProductsProps extends Omit<
  MobileProductCardProps,
  'checked'
> {
  customer: Customer;
  selectedProducts: Product[];
}

export const MobileSimilarProducts = ({
  product,
  customer,
  selectedProducts,
  ...rest
}: MobileSimilarProductsProps) => {
  const { products, isLoading } = useSimilarProducts({
    product,
    selectedCustomer: customer
  });

  if (isLoading) return <ListLoader />;

  if (!products?.length && !isLoading)
    return <ProductsEmptyState title="No similar products found" />;

  return products.map(i => {
    const isChecked = selectedProducts.some(j => j._id === i._id);
    return <MobileProductListCard product={i} {...rest} checked={isChecked} />;
  });
};
